export const WEEKDAYS_FR = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"];
export const WEEKDAYS_FULL = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];
export const MONTHS_FR = ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Août", "Sep", "Oct", "Nov", "Déc"];
export const MONTHS_FULL = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];

export function toISODate(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

// weekday index Monday=0 ... Sunday=6
export function mondayIndex(d) {
  return (d.getDay() + 6) % 7;
}

export function buildUpcomingDays(count = 21) {
  const days = [];
  const today = new Date();
  for (let i = 0; i < count; i++) {
    const d = new Date(today);
    d.setDate(today.getDate() + i);
    days.push(d);
  }
  return days;
}

export function formatDateFR(isoStr) {
  const [y, m, d] = isoStr.split("-").map(Number);
  const date = new Date(y, m - 1, d);
  return `${WEEKDAYS_FULL[mondayIndex(date)]} ${d} ${MONTHS_FULL[m - 1]} ${y}`;
}

function pad2(n) { return String(n).padStart(2, "0"); }

// Dynamic opening status based on weekly_hours + closed_dates (visitor local time).
export function getOpeningStatus(settings) {
  if (!settings || !settings.weekly_hours) return { open: false, label: "" };
  const wh = settings.weekly_hours;
  const closed = settings.closed_dates || [];
  const now = new Date();
  const todayIso = `${now.getFullYear()}-${pad2(now.getMonth() + 1)}-${pad2(now.getDate())}`;
  const nowMin = now.getHours() * 60 + now.getMinutes();
  const wd = mondayIndex(now);
  const cfgToday = wh[String(wd)];
  const isClosedDate = closed.includes(todayIso);
  const toMin = (s) => { const [a, b] = s.split(":").map(Number); return a * 60 + b; };

  const nextOpening = (fromOffset) => {
    for (let i = fromOffset; i <= 14; i++) {
      const d = new Date(now); d.setDate(now.getDate() + i);
      const iso = `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
      const w = mondayIndex(d);
      const c = wh[String(w)];
      if (c && c.open && !closed.includes(iso)) return { offset: i, start: c.start, dayName: WEEKDAYS_FULL[w] };
    }
    return null;
  };
  const whenLabel = (no) => {
    if (!no) return "";
    if (no.offset === 0) return `aujourd'hui à ${no.start}`;
    if (no.offset === 1) return `demain à ${no.start}`;
    return `${no.dayName.toLowerCase()} à ${no.start}`;
  };

  if (!isClosedDate && cfgToday && cfgToday.open) {
    const o = toMin(cfgToday.start), c = toMin(cfgToday.end);
    if (nowMin < o) return { open: false, label: `Ouvre à ${cfgToday.start}` };
    if (nowMin >= o && nowMin < c) {
      const left = c - nowMin;
      if (left <= 60) return { open: true, soon: true, label: `Ferme dans ${left} min` };
      return { open: true, label: `Ouvert · ferme à ${cfgToday.end}` };
    }
    return { open: false, label: `Fermé · ouvre ${whenLabel(nextOpening(1))}` };
  }
  const no = nextOpening(1);
  if (isClosedDate) return { open: false, label: no ? `Fermé pour congés · ouvre ${whenLabel(no)}` : "Fermé pour congés" };
  return { open: false, label: no ? `Fermé · ouvre ${whenLabel(no)}` : "Fermé" };
}
